﻿import { vec2 } from "gl-matrix";
import { EPointerButton } from "../input/input";

export interface IElementEvent {
    get clientX(): number;
    get clientY(): number;
    get touchCount(): number;
    get touches(): TouchList | null;
    get isPinching(): boolean;
    get ndc(): vec2;
    get isValidEvent(): boolean;

    get buttonPressed(): EPointerButton;
}

export abstract class ElementEvent implements IElementEvent {
    
    abstract get clientX(): number
    abstract get clientY(): number
    abstract get touchCount(): number
    abstract get touches(): TouchList
    abstract get isPinching(): boolean
    abstract get isValidEvent(): boolean;
    abstract get movementX(): number;
    abstract get movementY(): number;
    constructor(protected element: HTMLElement, protected ratio: number = 1.0) {

    }
    abstract get buttonPressed(): EPointerButton;
    abstract get anyButton(): boolean;
    get ndc() {
        return vec2.fromValues(
            (this.clientX * this.ratio / this.element.clientWidth) * 2 - 1,
            -(this.clientY * this.ratio / this.element.clientHeight) * 2 + 1
        )
    }

}

export class ElementPointerEvent extends ElementEvent implements IElementEvent {
    get anyButton(): boolean {
        return this._event.button > -1;
    }
    get movementX(): number {
        return this._event.movementX
    }
    get movementY(): number {
        return this._event.movementY
    }
    get isValidEvent(): boolean {
        return true;
    }
    get clientX(): number {
        return this._event.offsetX;
    }
    get clientY(): number {
        return this._event.offsetY;
    }
    get touchCount(): number {
        return 0;
    }
    get touches(): TouchList {
        return null;
    }
    get isPinching() { return false }

    constructor(protected _event: PointerEvent | MouseEvent, root: HTMLElement) {
        super(root);
    }
    get buttonPressed(): EPointerButton {
        return this._event.buttons as EPointerButton
    }

}

export class ElementTouchEvent extends ElementEvent implements IElementEvent {
    get anyButton(): boolean {
        return false;
    }
    get movementX(): number {
        return 0;
    }
    get movementY(): number {
        throw 0;
    }
    protected _rect: DOMRect;
    get touch() {
        return this._event.touches[0];
    }
    get clientX(): number {
        return this.touch.clientX - this._rect.left;
    }
    get clientY(): number {
        return this.touch.clientY - this._rect.top;
    }
    get touchCount(): number {
        return this.touches.length;
    }
    get touches(): TouchList {
        return this._event.touches;
    }
    get isPinching(): boolean {
        return this.touchCount > 1;
    }
    get isValidEvent() {
        return this.touchCount > 0;
    }
    constructor(protected _event: TouchEvent, root: HTMLElement) {
        super(root);

        this._rect = (_event.target as HTMLElement).getBoundingClientRect();

    }
    get buttonPressed(): EPointerButton {
        return null
    }

}
